import * as React from 'react';

import type { SupplierMonitoringClient } from '@/api/supplier-monitoring-client';
import { HttpSupplierMonitoringClient } from '@/api/supplier-monitoring-client.http';

// =============================================================================
// supplier-monitoring-client-context.tsx — Injection du SupplierMonitoringClient (DI seam).
// =============================================================================
// V-SUIVI-FOURN-read (PFP-2026-07-21-002). Permet de substituer le client sans toucher l'UI. Par DÉFAUT :
// l'adaptateur HTTP RÉEL — la route réelle n'a donc AUCUN provider à câbler (garde 09, parité
// operational-view-client-context). Les tests de composant injectent le StubSupplierMonitoringClient via ce
// provider (enveloppe locale), sans modifier l'infra de providers partagée.

const defaultSupplierMonitoringClient: SupplierMonitoringClient =
  new HttpSupplierMonitoringClient();

const SupplierMonitoringClientContext =
  React.createContext<SupplierMonitoringClient>(defaultSupplierMonitoringClient);

export interface SupplierMonitoringClientProviderProps {
  client?: SupplierMonitoringClient | undefined;
  children: React.ReactNode;
}

export function SupplierMonitoringClientProvider({
  client = defaultSupplierMonitoringClient,
  children,
}: SupplierMonitoringClientProviderProps): React.JSX.Element {
  return (
    <SupplierMonitoringClientContext.Provider value={client}>
      {children}
    </SupplierMonitoringClientContext.Provider>
  );
}

export function useSupplierMonitoringClient(): SupplierMonitoringClient {
  return React.useContext(SupplierMonitoringClientContext);
}
